import { render, staticRenderFns } from "./ParentProfileCard.vue?vue&type=template&id=1a38f1fa&scoped=true"
import script from "./ParentProfileCard.vue?vue&type=script&lang=js"
export * from "./ParentProfileCard.vue?vue&type=script&lang=js"
import style0 from "./ParentProfileCard.vue?vue&type=style&index=0&id=1a38f1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38f1fa",
  null
  
)

export default component.exports